// components/usePaystack.js
import { useCallback, useRef } from "react";
import Paystack from "@paystack/inline-js";


export default function usePaystack({ initializeUrl, onClientSuccess } = {}) {
  const popupRef = useRef(null);

  const startPayment = useCallback(
    async ({ email, amount, metadata = {} } = {}) => {
      if (!email || !amount) throw new Error("email and amount required");
      if(!metadata.propertyId) throw new Error("propertyId is required in metadata");
      // 1. call server to initialize
      const resp = await fetch(initializeUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, amount, metadata })
      });

      if (!resp.ok) {
        const err = await resp.json().catch(() => ({ message: "failed to initialize payment" }));
        throw new Error(err.message || "failed to initialize payment");
      }

      const data = await resp.json();
      const { access_code, authorization_url } = data;

      try {
        popupRef.current = popupRef.current || new Paystack();
        if (access_code) {
          popupRef.current.resumeTransaction(access_code);
        } else if (authorization_url) {
          window.location.href = authorization_url;
        } else {
          throw new Error("no access_code or authorization_url returned by server");
        }

        if (typeof onClientSuccess === "function") {
          onClientSuccess(data);
        }

        return data;
      } catch (err) {
        if (authorization_url) {
          window.location.href = authorization_url;
        } else {
          throw err;
        }
      }
    },
    [initializeUrl, onClientSuccess]
  );

  return { startPayment };
}
